import { useMutation, useQueryClient } from '@tanstack/react-query';
import { request } from '../axios.ts';
import type {
  IBezugsperson,
  ICreateBezugspersonPayload,
} from '../generated/bezugperson-controller/bezugperson-controller.ts';

export function createPatientBezugsperson(patientId: string, data: ICreateBezugspersonPayload) {
  return request<IBezugsperson>({
    url: `/api/patients/${patientId}/bezugspersonen`,
    method: 'POST',
    data,
  });
}

export function getPatientBezugspersonenQueryKey(patientId: string) {
  return ['patients', patientId, 'bezugspersonen'] as const;
}

export function useCreatePatientBezugspersonMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ patientId, data }: { patientId: string; data: ICreateBezugspersonPayload }) =>
      createPatientBezugsperson(patientId, data),
    onSuccess: (_, variables) => {
      void queryClient.invalidateQueries({
        queryKey: getPatientBezugspersonenQueryKey(variables.patientId),
      });
    },
  });
}
